/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { MobileTicket, UpdateApprovalAttributePayloadDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class MobileApprovalAttributeController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags mobile-approval-attribute-controller
   * @name UpdateApprovalAttribute
   * @request POST:/api/m/approval/attribute
   */
  updateApprovalAttribute = (data: UpdateApprovalAttributePayloadDto, params: RequestParams = {}) =>
    this.http.request<MobileTicket, any>({
      path: `/m/approval/attribute`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateApprovalAttributePath = '/m/approval/attribute'
  static updateApprovalAttributeMethod = 'POST'
}
